// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestIsosceles {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _isosceles?: vf.gui.Isosceles;
    private _buttonList: vf.gui.Label[] = [];
    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 绘制矩形 */
        const isosceles = this._isosceles = new vf.gui.Isosceles();
        isosceles.style.width = 200;
        isosceles.style.height = 300;
        isosceles.lineColor = "#ffffff";
        isosceles.lineWidth = 1;
        isosceles.upLine = 100;
        isosceles.downLine = 200;
        isosceles.x = 300;
        isosceles.y = 200;
        uiStage.addChild(isosceles);


        this.getButton('设置/取消width\\/height', () => {
            if (isosceles.width === 200) {
                isosceles.width = 300;
                isosceles.height = 200;
            } else {
                isosceles.width = 200;
                isosceles.height = 300;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消 fill', () => {
            if (isosceles.color === undefined) {
                isosceles.color = 0x00f00f;
            } else {
                isosceles.color = undefined;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 三角形', () => {
            if (isosceles.upLine === 100) {
                isosceles.upLine = 0;
            } else {
                isosceles.upLine = 100;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 虚线(虚线不能填充)', () => {
            if (isosceles.lineType === "full") {
                isosceles.lineType = "dash";
            } else {
                isosceles.lineType = "full";
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消 fillColor', () => {
            if (isosceles.style.fillGradientType !== 1) {
                isosceles.style.fillGradientType = 1
                isosceles.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                isosceles.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            } else {
                isosceles.style.fillGradientType = 0
                isosceles.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                isosceles.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            }

        }, uiStage, 15, 0);

    }

    private posY = 15;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
    }

    private onRelease() {
        if (this._isosceles) {
            this._isosceles.removeAllListeners();
            this._isosceles.parent && this._isosceles.parent.removeChild(this._isosceles);
            this._isosceles.release();
            this._isosceles = undefined;
        }

        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }


}

